export default "__VITE_ASSET__P_5DeDj4__"